var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadSegments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#898E99",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3672_9202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4161 19V17.4489L14.0404 14.093C14.3486 13.7947 14.6072 13.5263 14.816 13.2876C15.0281 13.049 15.1888 12.8153 15.2982 12.5866C15.4076 12.3546 15.4623 12.1044 15.4623 11.8359C15.4623 11.5376 15.3943 11.2808 15.2584 11.0653C15.1225 10.8466 14.9369 10.6792 14.7016 10.5632C14.4663 10.4439 14.1995 10.3842 13.9012 10.3842C13.5896 10.3842 13.3179 10.4472 13.0858 10.5732C12.8538 10.6991 12.6749 10.8797 12.5489 11.1151C12.423 11.3504 12.36 11.6304 12.36 11.9553H10.3167C10.3167 11.2891 10.4675 10.7107 10.7691 10.2202C11.0707 9.72964 11.4933 9.35014 12.0368 9.08168C12.5804 8.81321 13.2068 8.67898 13.9161 8.67898C14.6453 8.67898 15.28 8.80824 15.8202 9.06676C16.3638 9.32197 16.7864 9.67661 17.088 10.1307C17.3896 10.5848 17.5404 11.1051 17.5404 11.6918C17.5404 12.0762 17.4642 12.4557 17.3117 12.8303C17.1626 13.2048 16.8957 13.6207 16.5113 14.0781C16.1268 14.5322 15.5849 15.0774 14.8856 15.7138L13.3991 17.1705V17.2401H17.6746V19H10.4161Z",
    fill: "#898E99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3672_9202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 22,
    fill: "white",
    transform: "translate(9.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadSegments);
export default __webpack_public_path__ + "static/media/BroadSegments.c7f7e0d32dc9753ac94e213cc81a700f.svg";
export { ForwardRef as ReactComponent };